import * as React from "react";
import { Container, PaletteMode } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import AboutUsPage from "./about-us";
import BusinessValuePage from "./business-value";
import ContactUsPage from "./contact-us";
import FooterPage from "./footer";
import FrequentlyAskedQuestionsPage from "./frequently-asked-questions";
import HomePage from "./home";
import AppAppBar from "../../components/landing/app-bar";
import AboutResidentsPage from "./about-residents";
import SubscribePage from "./subscribe-page";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";
import { useEffect, useState } from "react";

function LandingPage() {
  const [mode, setMode] = useState<PaletteMode>("dark");
  const defaultTheme = createTheme({
    palette: { mode },
  });

  const toggleColorMode = () => {
    setMode((prev) => (prev === "dark" ? "light" : "dark"));
  };

  useEffect(() => {
    logEvent(analytics, "public_landing_page_load");
  }, []);

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <AppAppBar mode={mode} toggleColorMode={toggleColorMode} />
      <Container
        sx={{ bgcolor: "background.default", paddingTop: { xs: 8, sm: 16 } }}
      >
        <HomePage />
        <AboutUsPage />
        <BusinessValuePage />
        {/* <ServicesPage /> */}
        <FrequentlyAskedQuestionsPage />
        <ContactUsPage />
        <SubscribePage />
        <AboutResidentsPage />
        <FooterPage />
      </Container>
    </ThemeProvider>
  );
}

export default LandingPage;
